import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { BaseDict } from "./dict";
import { config } from "./config";
import { HeaderRegulationRibbonMessageBlock } from "./HeaderRegulationRibbonMessageBlock";
import { HeaderRegulationRibbonMessageBlockData } from "./data";
let _localMocks;
let _libMocks;
if (process.env.NODE_ENV === "development") {
    _libMocks = require("sb-msg-bus/lib-esm/mock");
    _localMocks = require("../../mocks");
}
export class HeaderRegulationRibbonMessageBlockRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
        navHandler: {},
        dataProvider: {},
        betSlipUtil: {},
        oddsUtil: {},
        facade: {}
    }) {
        super(domId, options);
        if (process.env.NODE_ENV === "development") {
            // setup data mocks for debug build
            this.dataProvider = new HeaderRegulationRibbonMessageBlockData({
                eventsManager: _localMocks.EventsManagerMock,
                messageBusProvider: new _libMocks.SBMsgBusMock()
            });
            // setup dictionary for debug build
            this.options.dict = BaseDict;
            this.options.cms = _localMocks.CmsMock;
            //export data store to window for debug purposes
            window["HeaderRegulationRibbonMessageBlockDATA"] = this.dataProvider;
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new HeaderRegulationRibbonMessageBlockData(options.dataProvider);
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        // merge default and CMS options
        this.options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
    }
    activate() {
        return super.activate(React.createElement(HeaderRegulationRibbonMessageBlock, { dataProvider: this.dataProvider, dict: this.options.dict, cms: this.options.cms }));
    }
}
window["HeaderRegulationRibbonMessageBlock"] = HeaderRegulationRibbonMessageBlockRoot;
broadcastBlockLoad("HeaderRegulationRibbonMessageBlock");
//# sourceMappingURL=index.js.map